import React from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import loadable from '@loadable/component';

import AdminPlaceholder from 'components/consumer/AdminPlaceholder';
import isNewConsumerApp from 'commons/isNewConsumerApp';
import SuspenseWithLoader from '../SuspenseWithLoader';
import PDPPlaceholder from '../PDP/PDPPlaceholder';
import ProductListingPagePlaceholder from '../ProductListingPage/ProductListingPagePlaceholder';

const specialCategories = {
  'mid-century-furniture': true,
  'small-space-furniture': true,
  modern: true,
  new: true,
};

const CategoryPage = loadable(
  () => import('../CategoryPage'),
  isNewConsumerApp
    ? { loading: ProductListingPagePlaceholder }
    : {
        fallback: <div />,
      }
);

const PDP = loadable(
  () => import('../PDP'),
  isNewConsumerApp
    ? { loading: PDPPlaceholder }
    : {
        fallback: <PDPPlaceholder />,
      }
);

const ProductAndCategory = props => {
  const { category, slug } = useParams();

  if (props?.isAdmin) {
    return (
      <AdminPlaceholder>
        ProductAndCategory Component Placeholder for Variant Builder. <br />
        The component will display the product page correctly in Consumer
      </AdminPlaceholder>
    );
  }

  if (specialCategories[category]) {
    const categoryPageSlug = `${category}/${slug}`;

    return (
      <SuspenseWithLoader
        fallback={<ProductListingPagePlaceholder />}
        key={categoryPageSlug}
      >
        <CategoryPage slug={categoryPageSlug} key={categoryPageSlug} />
      </SuspenseWithLoader>
    );
  }

  return (
    <SuspenseWithLoader fallback={<PDPPlaceholder />} key={slug}>
      <PDP key={slug} />
    </SuspenseWithLoader>
  );
};

ProductAndCategory.propTypes = {
  isAdmin: PropTypes.bool,
};

export default ProductAndCategory;
